import { render } from "./ProjectManagerProject.vue?vue&type=template&id=32d0fa79&ts=true"
import script from "./ProjectManagerProject.vue?vue&type=script&lang=ts"
export * from "./ProjectManagerProject.vue?vue&type=script&lang=ts"

import "./ProjectManagerProject.vue?vue&type=style&index=0&id=32d0fa79&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__